import '../Assets/css/App.css';
import NavigationBar from './navbar.tsx'
import Footer from './footer.tsx'
import { Routes, Route } from 'react-router-dom'
import Accueil from '../Pages/Accueil.tsx'
import Contact from '../Pages/Contact.tsx'
import Services from '../Pages/Services.tsx'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <NavigationBar/>
      <Routes>
        <Route path="/" element={<Accueil/>}/>
        <Route path="/Services" element={<Services/>}/>
        <Route path="/Contact" element={<Contact/>}/>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
